var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        disabled: _vm.disabled,
        placement: "bottom",
        width: "300",
        "popper-class": "no-padding-popover",
        trigger: "click",
      },
      model: {
        value: _vm.showPopover,
        callback: function ($$v) {
          _vm.showPopover = $$v
        },
        expression: "showPopover",
      },
    },
    [
      !_vm.disabled
        ? _c("xh-structure", {
            ref: "structure",
            attrs: {
              show: _vm.showPopover,
              radio: _vm.radio,
              "selected-data": _vm.dataValue,
            },
            on: { changeCheckout: _vm.checkStructure },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _c(
            "flexbox",
            {
              staticClass: "structure-container xh-form-border",
              class: [
                _vm.disabled ? "is_disabled" : "is_valid",
                { is_focus: _vm.showPopover },
              ],
              attrs: { wrap: "wrap" },
              nativeOn: {
                click: function ($event) {
                  return _vm.focusClick.apply(null, arguments)
                },
              },
            },
            [
              _vm._l(_vm.showDataValue, function (item, index) {
                return _c("div", { key: index, staticClass: "user-item" }, [
                  _vm._v(_vm._s(item.name) + "\n        "),
                  !_vm.disabled
                    ? _c("i", {
                        staticClass: "delete-icon el-icon-close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.deletestru(item, index)
                          },
                        },
                      })
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataValue.length > _vm.max
                ? _c("i", { staticClass: "el-icon-more" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                class: ["el-icon-arrow-up", { "is-reverse": _vm.showPopover }],
              }),
              _vm._v(" "),
              _vm.dataValue.length == 0
                ? _c("div", { staticClass: "add-item text-one-line" }, [
                    _vm._v(_vm._s(_vm.placeholder)),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }